
//Import React Hooks
import { useEffect, useState } from 'react'

//MUI
import Popover from '@mui/material/Popover';

//Import created components
import CreneauPopover from '../../components/creneaupopover/CreneauPopover.jsx'

//Utils 
import convertHoraire from '../../utils/convert_horaire.js';

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

function SessionEleve({ creneau, eleve }) {

    //// ----- popover management
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        //console.log(anchorEl)
    };
    const open = Boolean(anchorEl);
    const id = open ? 'popover-modif' : undefined;
    //// -- end of popover mgmt

    return (
        <div > {/* addittionnal empty div to make the popover work */}
            <div className="eleve-session" onClick={handleClick}>
                <div className="eleve-session-jour">
                    <p>{dayjs(creneau.date).format('DD/M')}</p>
                </div>
                <div className="eleve-session-heure">
                    <p>{convertHoraire(creneau.horaire, "horaire")}</p>
                </div>
            </div>

            <Popover
                className="creneau-popover-root"
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <CreneauPopover creneau={creneau} setAnchorEl={setAnchorEl} mode={"modif"} eleve={eleve} />
            </Popover>

        </div>
    );
}

export default SessionEleve;